// removed by extract-text-webpack-plugin
module.exports = {"editablesContainer":"styles__editablesContainer___3PtaP","editablesButton":"styles__editablesButton___IKpav","editablesText":"styles__editablesText___3El9M"};